import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
export type RequestAppointmentHeaderFragment = { __typename?: 'RequestAppointmentPageMetadata', email?: string | null, companyName: string, companyWebsite?: string | null, phoneNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, locality?: string | null, postalCode?: string | null, country?: string | null, logoUrl?: string | null };

export const RequestAppointmentHeaderFragmentDoc = gql`
    fragment RequestAppointmentHeader on RequestAppointmentPageMetadata {
  email
  companyName
  companyWebsite
  phoneNumber
  addressLine1
  addressLine2
  locality
  postalCode
  country
  logoUrl
}
    `;